(() => {
  const initialise = root => {
    if (root.dataset.postReady) return;
    root.dataset.postReady = 'true';
    const contents = root.querySelector('[data-mm-post-contents]');
    if (contents && window.matchMedia('(max-width: 760px)').matches) contents.open = false;
    const printButton = root.querySelector('[data-mm-post-print]');
    if (printButton) {
      printButton.hidden = false;
      printButton.addEventListener('click', () => window.print());
    }
    if (root.dataset.postType !== 'recipe') return;
    const body = root.querySelector('[data-mm-post-body]');
    const ingredientsHeading = body?.querySelector('#recipe-ingredients');
    const list = ingredientsHeading?.nextElementSibling;
    if (!list || list.tagName !== 'UL') return;
    list.classList.add('mm-post__ingredients');
    Array.from(list.children).forEach(item => {
      if (item.tagName !== 'LI' || item.querySelector('input')) return;
      const label = document.createElement('label');
      label.className = 'mm-post__ingredient';
      const input = document.createElement('input');
      input.type = 'checkbox';
      const text = document.createElement('span');
      while (item.firstChild) text.appendChild(item.firstChild);
      label.append(input, text);
      item.appendChild(label);
    });
  };
  document.querySelectorAll('[data-mm-journal-post]').forEach(initialise);
  document.addEventListener('shopify:section:load', event => {
    event.target.querySelectorAll('[data-mm-journal-post]').forEach(initialise);
  });
})();
